// 各个端口的登录页面
const Login = () =>
  import(/* webpackChunkName: "passport" */ '@/pages/passport/Login');

// 各个端口的登录页面
const Document = () =>
  import(/* webpackChunkName: "passport" */ '@/pages/passport/Document');

export default [
  {
    path: '/passport/login',
    name: 'passport_login',
    meta: { title: '后台管理系统' },
    component: Login
  },
  {
    path: '/passport/document',
    name: 'passport_document',
    meta: { title: '后台管理系统' },
    component: Document
  }

];
